"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeToken = exports.setToken = exports.hasToken = exports.getToken = exports.TOKEN_KEY = void 0;
exports.TOKEN_KEY = 'token';
var getToken = function getToken() {
  return localStorage.getItem(exports.TOKEN_KEY);
};
exports.getToken = getToken;
var hasToken = function hasToken() {
  return localStorage.getItem(exports.TOKEN_KEY) !== null;
};
exports.hasToken = hasToken;
var setToken = function setToken(idToken) {
  localStorage.setItem(exports.TOKEN_KEY, idToken);
};
exports.setToken = setToken;
var removeToken = function removeToken() {
  localStorage.removeItem(exports.TOKEN_KEY);
};
exports.removeToken = removeToken;
//# sourceMappingURL=storage.js.map